import { render, staticRenderFns } from "./xreporteinsm.vue?vue&type=template&id=220654d4"
import script from "./xreporteinsm.vue?vue&type=script&lang=js"
export * from "./xreporteinsm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports